import React, { useState, useEffect } from "react";

function Chat() {
  const [logo, setLogo] = useState("");
  const [logoFailed, setLogoFailed] = useState(false);
  const [sociallink, setSociallink] = useState([]);
  const [whatsappLink, setWhatsappLink] = useState(null);

  // Fetch logo
  useEffect(() => {
    let cancelled = false;
    // safety net: never leave the button invisible if the logo never arrives
    const fallbackTimer = setTimeout(() => {
      if (!cancelled) setLogoFailed(true);
    }, 6000);

    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        const mobileLogo = data?.[0]?.mobile_logo;
        if (!mobileLogo) throw new Error("No mobile logo");
        if (cancelled) return;
        setLogo(`${process.env.REACT_APP_API_URL}/storage/${mobileLogo}`);
        setLogoFailed(false);
      } catch (error) {
        console.error("Error fetching logo:", error);
        if (!cancelled) setLogoFailed(true);
      } finally {
        clearTimeout(fallbackTimer);
      }
    };

    fetchLogo();
    return () => {
      cancelled = true;
      clearTimeout(fallbackTimer);
    };
  }, []);
  useEffect(() => {
    if (window.location.origin === "https://www.chat.com") {
      window.__lc = window.__lc || {};
      window.__lc.license = 19116631;

      (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on: function () {
            i(["on", c.call(arguments)]);
          },
          once: function () {
            i(["once", c.call(arguments)]);
          },
          off: function () {
            i(["off", c.call(arguments)]);
          },
          get: function () {
            if (!e._h)
              throw new Error("[LiveChatWidget] You can't use getters before load.");
            return i(["get", c.call(arguments)]);
          },
          call: function () {
            i(["call", c.call(arguments)]);
          },
          init: function () {
            var n = t.createElement("script");
            n.async = !0;
            n.type = "text/javascript";
            n.src = "https://cdn.livechatinc.com/tracking.js";
            t.head.appendChild(n);
          },
        };
        !n.__lc.asyncInit && e.init();
        n.LiveChatWidget = n.LiveChatWidget || e;
      })(window, document, [].slice);
    }
  }, []);

  

	const [show, setShow] = useState(null);
	useEffect(() => {
		let whatsapp = localStorage.getItem("whatsapp");
		let live_chat = localStorage.getItem("liveChat");
		// let intercom = localStorage.getItem("intercom");
		if (live_chat!=='null') {
			setShow('live_chat');
		}else {
			setShow('base_chat');
		}
		setWhatsappLink((whatsapp!=='null') ? whatsapp : null);
	}, [show]);

 

  // The button is pinned by CSS (.floating-left) so it always sits in the same
  // column as the free spin wheel — no dragging, so scrolling can never move
  // the chat button or make it overlap the wheel.

	// Listen for the custom event to open chat
	useEffect(() => {
		window.addEventListener('open_chat', function () {
			handleChatClick();
		});
	}, [show]);

	
	const handleChatClick = (e) => {
		console.log("Chat Clicked!");
		if (whatsappLink == null || whatsappLink.length === 0) { 
			let wan = localStorage.getItem("whatsapp")!== 'null' ? false : localStorage.getItem("whatsapp");
			setWhatsappLink(wan ?? false);
		}
		console.log("wa:",whatsappLink);
		if (e) {
			e.preventDefault();
		}

		const remoteId = localStorage.getItem("remote_id");
		const username = localStorage.getItem("username");
		
		if (window.Intercom) {
			window.Intercom("show");
		}else if (whatsappLink && whatsappLink!=null && whatsappLink !== 'null' && whatsappLink.length > 0) {
			console.log("WhatsApp Link:", whatsappLink);
			window.open(whatsappLink, "_blank");
		} else {
			if (window?.anw2 !== undefined) {
				console.log('anw2');
				window.anw2.open();
			}
			if (window.LiveChatWidget) {
				console.log('lch');
				window.LiveChatWidget.once("ready", () => {
					if (remoteId && username) {
						window.LiveChatWidget.call("set_customer_data", {
							name: username,
							external_id: remoteId, 
						});
					}
					window.LiveChatWidget.call("maximize");
				});
			}
			if (window.Tawk_API) {
				window.Tawk_API.maximize();
			}
		}
  	};
  
	

	return (
	  <>
		<style>{`
			[id^="anw2-launcher-container-"] [id^="anw2-launcher-"]{
				display: none !important;
			}
		`}</style>
	   <div onClick={handleChatClick} id="my_custom_link" className="floating-left"
                style={{
                position: "fixed",
                cursor: "pointer",
                // purple circle is a fallback only – normally the logo fills the button
                backgroundColor: logoFailed ? "#7a2bc2" : "transparent"
				}}
                >
                  {logo && !logoFailed ? (
                    <img src={logo} alt="live-chat" onError={() => setLogoFailed(true)} />
                  ) : null}
                </div>
    	
	</>
  );
}

export default Chat;